import _asyncToGenerator from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/var/www/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { USER_QUERY } from "../apollo/queries";
import { initalizeCache } from '../apollo/apolloStore';
export var requestQuery = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(apolloClient, gqlQuery) {
    var _yield$apolloClient$q, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return apolloClient.query({
              query: gqlQuery
            });
          case 3:
            _yield$apolloClient$q = _context.sent;
            data = _yield$apolloClient$q.data;
            return _context.abrupt("return", data);
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", null);
          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
  return function requestQuery(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
function getAuthenticatedUser() {
  var authenticatedUser = null;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(apolloClient) {
      var user;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(typeof window !== 'undefined' && authenticatedUser)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", authenticatedUser);
            case 2:
              _context2.prev = 2;
              initalizeCache(apolloClient.cache);
              _context2.next = 6;
              return requestQuery(apolloClient, USER_QUERY);
            case 6:
              user = _context2.sent;
              if (!(user && user.me)) {
                _context2.next = 10;
                break;
              }
              authenticatedUser = user.me;
              return _context2.abrupt("return", authenticatedUser);
            case 10:
              return _context2.abrupt("return", null);
            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](2);
              return _context2.abrupt("return", null);
            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 13]]);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
}
export var checkAuthentication = getAuthenticatedUser();